import { render, staticRenderFns } from "./HabeasDataForm.vue?vue&type=template&id=0146f25f&"
import script from "./HabeasDataForm.vue?vue&type=script&lang=js&"
export * from "./HabeasDataForm.vue?vue&type=script&lang=js&"
import style0 from "./HabeasDataForm.vue?vue&type=style&index=0&id=0146f25f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports